import React from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { AdressDetail } from "../components/fieldDetails"
import { rhythm } from "../utils/typography"
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

const MAX_SUMMARY_TEXT_LIMIT = 140;

const EntityEntry =  styled.article`
  display: flex;
  margin-bottom: ${rhythm(1)};
`

const EntityImage =  styled.div`
  flex: 25%;
  margin-right: ${rhythm(1)};
`

const EntitySummary =  styled.div`
  flex: ${props => props.fullWidth ? "75" : "100"}%;
`

const EnitySummary = node => {
  const content = (node.content && node.content.content) || null;
  if (!content) return null;

  const entitySummaryContent = documentToHtmlString(JSON.parse(content)).replace(/(<([^>]+)>)/ig,"");

  if (entitySummaryContent.length > MAX_SUMMARY_TEXT_LIMIT) {
    return (
      <p>
        {entitySummaryContent.substring(0, MAX_SUMMARY_TEXT_LIMIT)}...<br />
        <Link style={{ boxShadow: `none` }} to={node.slug}>Read more &raquo;</Link>
      </p>
    );
  } else {
    return <p>{entitySummaryContent}</p>
  }
}

const BlogIndex = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title
  const posts = data.allContentfulEntity.edges;

  return (
    <Layout location={location} title={siteTitle}>
      <SEO title="All Green Funeral Directors" />
      {posts.map(({ node }) => {
        const name = node.name || node.slug; 
        
        return (
          <EntityEntry key={node.slug}>
            {node.image &&
              <EntityImage>
                <Img fluid={node.image.fluid} />
              </EntityImage>
            }
            <EntitySummary hasImage={node.image}>
              <header>
                <h3
                  style={{
                    marginBottom: 0,
                    marginTop: 0,
                  }}
                >
                  <Link style={{ boxShadow: `none` }} to={node.slug}>
                    {name}
                  </Link>
                </h3>
              </header>
              <section>
                <AdressDetail {...node} />
                <EnitySummary {...node} />
              </section>
            </EntitySummary>
          </EntityEntry>
        )
      })}
    </Layout>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query ($countryCode: String!) {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulEntity(
      filter: {
        countryCode: {eq: $countryCode}
      },
      sort: {fields: [slug], order: ASC},
      limit: 1000
    ) {
      edges {
        node {
          name
          slug
          address
          county
          city
          postcode
          country
          content {
            content
          }
          image {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
  }
`
